<script>
import { EXAMINATION } from "@/utils/data";
export default {
  name: "marking",
  data() {
    return {
      TYPE: EXAMINATION.TYPE,
      TYPE_NAME: EXAMINATION.TYPE_NAME,
      SCORE_STATUS_NAME: EXAMINATION.SCORE_STATUS_NAME,
      SCORE_STATUS: EXAMINATION.SCORE_STATUS,
      testId: "",
      // 用户列表
      userLoading: false,
      userList: [],
      // 详情
      userId: "",
      paperId: "",
      detailLoading: false,
      questionList: [],
      paperTitle: "",
      paperScore: "",
      // 得分
      markingStatus: "",
      username: "",
      userScore: 0,
      userCorrect: 0,
      userIncorrect: 0,
      markingCount: 0,
      markingProgress: 0,
    };
  },
  mounted() {
    this.testId = this.$route.query.testId;
    this.getData();
  },
  methods: {
    getData() {
      if (!this.testId) {
        return;
      }
      this.userLoading = true;
      this.$cloud
        .get("examination/test/score?testId=" + this.testId)
        .then((res) => {
          console.log("res", res);
          this.userList = res;
        })
        .finally(() => {
          this.userLoading = false;
        });
    },
    getDetail(userId) {
      this.userId = userId;
      this.detailLoading = true;
      this.$cloud
        .get("examination/test/score/user", {
          testId: this.testId,
          userId,
        })
        .then((res) => {
          console.log("res", res);
          this.paperId = res.id;
          this.paperTitle = res.name;
          this.paperScore = res.score;
          this.markingStatus = res.status;
          this.username = res.user.username;
          this.userScore = 0;
          this.userCorrect = 0;
          this.userIncorrect = 0;
          this.markingCount = 0;
          this.questionList = res.questionList.map((v) => {
            v["marking"] = false;
            if (
              v.type === EXAMINATION.TYPE.SINGLE ||
              v.type === EXAMINATION.TYPE.MULTIPLE
            ) {
              v["marking"] = true;
              this.markingCount++;
              if (v.userAnswer.answer === v.answer) {
                this.userCorrect++;
                this.userScore += v.score;
                v.userAnswer.score = v.score;
              } else {
                this.userIncorrect++;
                v.userAnswer.score = 0;
              }
            }
            if (
              v.type === EXAMINATION.TYPE.INPUT &&
              (v.userAnswer.score || v.userAnswer.score === 0)
            ) {
              v["marking"] = true;
              this.userScore += v.userAnswer.score;
              this.markingCount++;
            }
            v["result"] = v.userAnswer.answer === v.answer;
            return v;
          });
          this.markingProgress = parseInt(
            (this.markingCount / this.questionList.length) * 100
          );
        })
        .finally(() => {
          this.detailLoading = false;
        });
    },
    createOptions(options) {
      let list = [];
      try {
        list = JSON.parse(options);
      } catch (e) {
        console.log("转换失败", e);
      }
      return list;
    },
    changeInputQuestion(item) {
      item["marking"] = true;
      this.updateProgress();
    },
    updateProgress() {
      let count = 0;
      this.questionList.forEach((v) => {
        if (v.marking) {
          count++;
        }
      });
      this.markingProgress = parseInt((count / this.questionList.length) * 100);
    },
    calculateScore() {
      let score = 0;
      this.questionList.forEach((v) => {
        if (v.marking) {
          score += v.userAnswer.score;
        }
      });
      this.userScore = score;
    },
    submitMarking() {
      if (this.markingProgress !== 100) {
        this.$alert("还有未批阅的题目");
        return;
      }
      let question = this.questionList.map((v) => {
        return {
          questionId: v.id,
          score: v.userAnswer.score,
        };
      });
      console.log("提交批阅", question);
      this.$confirm("提交批阅结果?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        beforeClose: (action, instance, done) => {
          console.log("action, done", action, done);
          console.log("instance", instance);
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            this.$cloud
              .post("examination/test/marking", {
                testId: this.testId,
                userId: this.userId,
                paperId: this.paperId,
                questionList: question,
              })
              .then(() => {
                this.$message({
                  type: "success",
                  message: "提交成功!",
                });
                done();
              })
              .finally(() => {
                instance.confirmButtonLoading = false;
                this.getDetail(this.userId);
                this.getData();
              });
          } else {
            done();
          }
        },
      }).then(() => {});
    },
  },
};
</script>

<template>
  <div class="flex h-full">
    <div class="user-list w-52 h-full border-r-2">
      <el-scrollbar class="h-full">
        <div class="h-2"></div>
        <div
          v-for="user in userList"
          :key="'user' + user.id"
          :class="{ 'bg-red-100': user.userId === userId }"
          class="
            flex
            h-10
            hover:bg-red-200
            transition-all
            ml-2
            mr-2
            rounded
            pl-2
            pr-2
            select-none
          "
          @click="getDetail(user.userId)"
        >
          <div class="flex-1 leading-10">
            {{ user.user.username }}
          </div>
          <div class="w-14 leading-9">
            <el-tag
              :type="user.status === SCORE_STATUS.RATED ? 'success' : ''"
              >{{ SCORE_STATUS_NAME[user.status] }}</el-tag
            >
          </div>
          <div class="w-8 ml-2 leading-9">
            <el-tag effect="dark" v-if="user.status === SCORE_STATUS.RATED">
              {{ user.score }}
            </el-tag>
          </div>
        </div>
        <div class="h-2"></div>
      </el-scrollbar>
    </div>
    <div
      class="question-list flex-1 overflow-y-auto h-full"
      v-if="paperTitle"
      v-loading="detailLoading"
    >
      <el-scrollbar class="h-full">
        <p class="paper-title">{{ paperTitle }}</p>
        <p class="paper-score">{{ paperScore }}分</p>
        <div class="paper-list ml-20 mr-20">
          <div
            class="paper-question mb-2"
            v-for="(question, index) in questionList"
            :key="'question' + userId + '-' + index"
          >
            <div class="question-title text-xl">
              {{ index + 1 }}、{{ question.name }} (
              {{ TYPE_NAME[question.type] }}
              )
            </div>
            <div v-if="question.type === TYPE.SINGLE">
              <div
                class="mr-10"
                :key="'option' + option.value + question.id"
                v-for="option in createOptions(question.options)"
              >
                {{ option.value }} 、 {{ option.name }}
              </div>
              <div>参考答案：{{ question.answer }}</div>
              <div>用户选择：{{ question.userAnswer.answer }}</div>
              <div>
                答题结果:
                <el-tag :type="question.result ? 'success' : 'error'">
                  {{ question.result ? "正确" : "错误" }}
                </el-tag>
              </div>
              <div>得分：{{ question.userAnswer.score }}分</div>
            </div>
            <div v-if="question.type === TYPE.MULTIPLE">
              <div
                class=""
                :key="'option' + question.id + option.value"
                v-for="option in createOptions(question.options)"
              >
                {{ option.value }} 、 {{ option.name }}
              </div>
              <div>
                参考答案：
                {{ question.answer ? question.answer.join("、") : "" }}
              </div>
              <div>
                用户选择：
                {{
                  question.userAnswer.answer
                    ? question.userAnswer.answer.join("、")
                    : ""
                }}
              </div>
              <div>
                答题结果:
                <el-tag :type="question.result ? 'success' : 'error'">
                  {{ question.result ? "正确" : "错误" }}
                </el-tag>
              </div>
              <div>得分：{{ question.userAnswer.score }}分</div>
            </div>
            <div class="h-20" v-if="question.type === TYPE.INPUT">
              <div>用户输入：{{ question.userAnswer.answer }}</div>
              <div>
                得分：
                <el-input-number
                  v-if="markingStatus !== SCORE_STATUS.RATED"
                  :min="0"
                  :max="question.score"
                  v-model="question.userAnswer.score"
                  @click.native.once="changeInputQuestion(question)"
                  @change="calculateScore"
                />
                <span v-else>{{ question.userAnswer.score }}</span
                >分
              </div>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>
    <div
      class="result w-72 border-l-2 h-full pr-2 pl-2 pt-2"
      v-if="paperTitle"
      v-loading="detailLoading"
    >
      <div>
        {{ username }}
      </div>
      <div>得分:{{ userScore }}</div>
      <div>正确题数:{{ userCorrect }}</div>
      <div>错误题数:{{ userIncorrect }}</div>
      <div>
        <el-progress :percentage="markingProgress" />
      </div>
      <div>
        批阅题目详情:
        <div class="question-answer-list overflow-y-auto grid grid-cols-5">
          <div
            class="
              question-answer
              bg-red-100
              w-10
              h-10
              text-center
              leading-10
              select-none
              rounded
              transition-all
              hover:bg-red-200
            "
            :class="{ 'bg-red-400': item.marking }"
            v-for="(item, index) in questionList"
            :key="'list' + userId + '-' + index"
          >
            {{ index + 1 }}
          </div>
        </div>
      </div>
      <div v-if="markingStatus !== SCORE_STATUS.RATED" class="mt-4">
        <el-button type="primary" class="w-full" @click="submitMarking"
          >批阅完成</el-button
        >
      </div>
    </div>
  </div>
</template>

<style scoped>
.paper-title {
  text-align: center;
  font-weight: bold;
  font-size: 30px;
}
.paper-score {
  text-align: center;
}
.question-answer-list {
  grid-auto-flow: row;
  grid-row-gap: 14px;
  align-content: start;
}
</style>
